import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTheme } from 'react-jss';
import cx from '@/utils/cx';
import useStyle from './style';

const CACHE_STORE_KEY = 'ui-kit-icon-cache-store';

const loadIcon = (src) => {
  const cacheStore = JSON.parse(localStorage.getItem(CACHE_STORE_KEY) || '{}');
  const cacheKey = btoa(src);
  const cacheItem = cacheStore[cacheKey];
  if (typeof cacheItem === 'string') {
    return new Promise((resolve) => resolve(cacheItem));
  }
  return fetch(src).then((res) => res.text()).then((res) => {
    cacheStore[cacheKey] = res;
    localStorage.setItem(CACHE_STORE_KEY, JSON.stringify(cacheStore));
    return res;
  });
};

const Icon = ({
  src,
  color,
  size,
  flipViaDirection,
  className,
  rotation,
  viewBox,
  ...rest
}) => {
  const theme = useTheme();
  const classes = useStyle({
    size, color, flipViaDirection, rotation,
  });

  const [svg, setSvg] = useState('');

  useEffect(() => {
    setSvg('');
    loadIcon(src)
      .then((svgContent) => {
        const viewBoxText = viewBox || theme.defaultIconsViewBox;
        const svgProps = ` width="${size}" height="${size}" color="${color}" viewBox="${viewBoxText}"`;
        const optimizedSvg = svgContent;
        const svgTagMatch = optimizedSvg.match(/<svgz|<svgx|<svg/i);
        if (!svgTagMatch) {
          return;
        }
        const findSvgTag = svgTagMatch[0];
        setSvg(
          findSvgTag
          + svgProps
          + optimizedSvg.substr(findSvgTag.length),
        );
      });
  }, [src]);

  return (
    <i
      className={cx(classes.icon, className)}
      /* eslint-disable-next-line react/no-danger */
      dangerouslySetInnerHTML={{ __html: svg }}
      {...rest}
    />
  );
};

Icon.propTypes = {
  src: PropTypes.string,
  className: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  rotation: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  flipViaDirection: PropTypes.bool,
  viewBox: PropTypes.string,
};

Icon.defaultProps = {
  src: '',
  className: '',
  color: '#333',
  size: 16,
  rotation: 0,
  flipViaDirection: false,
  viewBox: undefined,
};

export default Icon;
